<template>
  <div class="finance-container">
    <!-- 头部统计和筛选 -->
    <!-- <div class="finance-header">
            <div class="header-main">
                <h1 class="page-title">资金流水</h1>
                <div class="balance-card">
                    <div class="balance-label">当前余额</div>
                    <div class="balance-amount">${{ currentBalance }}</div>
                    <div class="balance-trend">
                        <i class="fas fa-arrow-up" v-if="balanceTrend > 0"></i>
                        <i class="fas fa-arrow-down" v-else></i>
                        {{ Math.abs(balanceTrend) }}%
                    </div>
                </div>
            </div>

            <div class="header-actions">
                <div class="filter-group">
                    <div class="filter-item">
                        <label>类型</label>
                        <select v-model="filters.type" class="filter-select">
                            <option value="all">全部类型</option>
                            <option value="income">收入</option>
                            <option value="expense">支出</option>
                        </select>
                    </div>
                    <div class="filter-item">
                        <label>时间范围</label>
                        <select v-model="filters.dateRange" class="filter-select">
                            <option value="all">全部时间</option>
                            <option value="today">今天</option>
                            <option value="week">本周</option>
                            <option value="month">本月</option>
                        </select>
                    </div>
                </div>

                <div class="search-export">
                    <div class="search-box">
                        <i class="fas fa-search"></i>
                        <input v-model="filters.search" type="text" placeholder="搜索类型或金额..." class="search-input">
                    </div>
                    <button class="export-btn" @click="exportData">
                        <i class="fas fa-download"></i>
                        导出数据
                    </button>
                </div>
            </div>
        </div> -->

    <!-- 统计卡片 -->
    <!-- <div class="stats-cards">
            <div class="stat-card">
                <div class="stat-icon income">
                    <i class="fas fa-arrow-down"></i>
                </div>
                <div class="stat-content">
                    <div class="stat-value">${{ totalIncome }}</div>
                    <div class="stat-label">总收入</div>
                </div>
            </div>

            <div class="stat-card">
                <div class="stat-icon expense">
                    <i class="fas fa-arrow-up"></i>
                </div>
                <div class="stat-content">
                    <div class="stat-value">${{ totalExpense }}</div>
                    <div class="stat-label">总支出</div>
                </div>
            </div>

            <div class="stat-card">
                <div class="stat-icon transaction">
                    <i class="fas fa-exchange-alt"></i>
                </div>
                <div class="stat-content">
                    <div class="stat-value">{{ totalTransactions }}</div>
                    <div class="stat-label">交易笔数</div>
                </div>
            </div>

            <div class="stat-card">
                <div class="stat-icon frozen">
                    <i class="fas fa-lock"></i>
                </div>
                <div class="stat-content">
                    <div class="stat-value">${{ totalFrozen }}</div>
                    <div class="stat-label">冻结金额</div>
                </div>
            </div>
        </div> -->

    <!-- 筛选和搜索 -->
    <!-- <div class="filter-bar">
      <div class="filter-group">
        <button v-for="filter in timeFilters" :key="filter.value" :class="['filter-btn', { active: activeTimeFilter === filter.value }]" @click="activeTimeFilter = filter.value">
          {{ filter.label }}
        </button>
      </div>
      <div class="search-box">
        <i class="fas fa-search"></i>
        <input v-model="searchQuery" type="text" :placeholder="$t('_jyjl._ssdz')" class="search-input" />
      </div>
    </div> -->

    <!-- 交易列表 -->
    <div class="transaction-section">
      <!-- <div class="section-header">
                <h3 class="section-title">交易记录</h3>
                <div class="section-actions">
                    <button v-for="sort in sortOptions" :key="sort.value"
                        :class="['sort-btn', { active: filters.sortBy === sort.value }]"
                        @click="filters.sortBy = sort.value">
                        {{ sort.label }}
                    </button>
                </div>
            </div> -->

      <div class="transaction-list">
        <div class="t-table-header">
          <div class="header-cell type" style="width: 20%">{{ $t('_jyjl._lx') }}</div>
          <div class="header-cell amount" style="width: 20%">{{ $t('_jyjl._je') }}</div>
          <div class="header-cell balance" style="width: 20%">{{ $t('_jyjl._ye') }}</div>
          <div class="header-cell frozen" style="width: 20%">{{ $t('_jyjl._dj') }}</div>
          <div class="header-cell frozen" style="width: 20%">{{ $t('_sp._dbye') }}</div>
          <div class="header-cell time" style="width: 20%">{{ $t('_jyjl._sj') }}</div>
          <div class="header-cell actions" style="width: 20%">{{ $t('_jyjl._cz') }}</div>
        </div>

        <div v-for="(transaction, i) in transactions" :key="i" class="t-transaction-item">
          <div class="table-cell type" style="width: 20%">
            <div class="type-info">
              <!-- <div class="type-icon" :class="getTypeClass(transaction.type)">
                                <i :class="getTypeIcon(transaction.type)"></i>
                            </div> -->
              <div class="type-details">
                <div class="type-name">{{ $t('_jyjl._tp' + transaction.type) }}</div>
                <div class="type-desc">{{ getTypeDesc(transaction.type) }}</div>
              </div>
            </div>
          </div>

          <div class="table-cell amount" style="width: 20%">
            <div class="amount-display" :class="transaction.classify == 1 ? 'expense' : 'income'">{{ transaction.classify == 1 ? '-' : '+' }} ${{ transaction.number }}</div>
          </div>

          <div class="table-cell balance" style="width: 20%">
            <div class="balance-display">${{ transaction.balance }}</div>
          </div>

          <div class="table-cell frozen" style="width: 20%">
            <div class="frozen-display" :class="{ 'has-frozen': transaction.freeze > 0 }">${{ transaction.freeze }}</div>
          </div>
          <div class="table-cell frozen" style="width: 20%">
            <div class="frozen-display" :class="{ 'has-frozen': transaction.video > 0 }">${{ transaction.video }}</div>
          </div>

          <div class="table-cell time" style="width: 20%">
            <div class="time-display">
              <div class="time-date">{{ formatDate(transaction.create_time) }}</div>
              <div class="time-hour">{{ formatTime(transaction.create_time) }}</div>
            </div>
          </div>

          <div class="table-cell actions" style="width: 20%">
            <div class="action-buttons">
              <button class="action-btn detail-btn" @click="showDetail(transaction)">
                <eye-outlined />
              </button>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-if="transactions?.length === 0" class="empty-state">
          <div class="empty-icon">
            <i class="fas fa-receipt"></i>
          </div>
          <h3>{{ $t('_jyjl._zwjyjl') }}</h3>
          <!-- <p>当前筛选条件下没有找到交易记录</p> -->
          <button class="reset-filter-btn" @click="resetFilters">
            <i class="fas fa-refresh"></i>
            {{ $t('_jyjl._czsx') }}
          </button>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination" v-if="transactions?.length > 0">
      <button class="page-btn" :disabled="page === 1" @click="onPage(page - 1)">
        <left-outlined />
      </button>
      <span class="page-info">{{ $t('_jyjl._dny', { a: page, b: totalPages }) }}</span>
      <button class="page-btn" :disabled="page === totalPages" @click="onPage(page + 1)">
        <right-outlined />
      </button>
    </div>

    <!-- 交易详情弹窗 -->
    <div v-if="selectedTransaction" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ $t('_jyjl._jyxq') }}</h3>
          <button class="close-btn" @click="selectedTransaction = null">
            <CloseCircleOutlined />
          </button>
        </div>
        <div class="modal-body">
          <div class="detail-item">
            <span class="detail-label">{{ $t('_jyjl._jylx') }}:</span>
            <span class="detail-value">{{ $t('_jyjl._tp' + selectedTransaction.type) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ $t('_jyjl._jyje') }}:</span>
            <span class="detail-value" :class="selectedTransaction.classify == 1 ? 'expense' : 'income'"> {{ selectedTransaction.classify == 1 ? '-' : '+' }} ${{ selectedTransaction.number }} </span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ $t('_jyjl._jyhye') }}:</span>
            <span class="detail-value">${{ selectedTransaction.balance }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ $t('_jyjl._djye') }}:</span>
            <span class="detail-value">${{ selectedTransaction.freeze }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ $t('_jyjl._jysj') }}:</span>
            <span class="detail-value">{{ formatFullTime(selectedTransaction.create_time) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ $t('_jyjl._jyzt') }}:</span>
            <span class="status-badge completed">{{ $t('_jyjl._ywc') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EyeOutlined, RightOutlined, LeftOutlined, CloseCircleOutlined } from '@ant-design/icons-vue'
export default {
  name: 'FinanceRecords',
  components: { EyeOutlined, RightOutlined, LeftOutlined, CloseCircleOutlined },
  data() {
    return {
      selectedTransaction: null,
      filters: {
        type: 'all',
        dateRange: 'all',
        search: '',
        sortBy: 'time'
      },
      //   sortOptions: [
      //     { label: '最新', value: 'time' },
      //     { label: '金额', value: 'amount' },
      //     { label: '类型', value: 'type' }
      //   ],

      activeTimeFilter: 'all',
      timeFilters: [
        { label: this.$t('_jyjl._qb'), value: 'all' },
        { label: this.$t('_jyjl._jt'), value: 'today' },
        { label: this.$t('_jyjl._j7t'), value: '7days' },
        { label: this.$t('_jyjl._j30t'), value: '30days' }
      ],

      total: 0,
      page: 1,
      pageSize: 10,
      loading: false,
      transactions: []
    }
  },
  created() {
    this.getWalletLogList()
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize)
    }
    // currentBalance() {
    //   return this.transactions[0]?.balance || '0.00'
    // },
    // balanceTrend() {
    //   return 2.5 // 模拟数据
    // },
    // totalIncome() {
    //   return this.transactions
    //     .filter((t) => t.amountValue > 0)
    //     .reduce((sum, t) => sum + t.amountValue, 0)
    //     .toFixed(2)
    // },
    // totalExpense() {
    //   return Math.abs(this.transactions.filter((t) => t.amountValue < 0).reduce((sum, t) => sum + t.amountValue, 0)).toFixed(2)
    // },
    // totalTransactions() {
    //   return this.transactions.length
    // },
    // totalFrozen() {
    //   return this.transactions.reduce((sum, t) => sum + parseFloat(t.freeze), 0).toFixed(2)
    // }
  },
  methods: {
    onPage(page) {
      this.page = page
      this.getWalletLogList()
    },
    getWalletLogList() {
      let that = this
      var hide = this.$message.loading({ content: 'loading...', key: 'msg' })
      this.$api.userWallet
        .getWalletLogList({
          page: that.page,
          size: that.pageSize,
          search: ''
        })
        .then((res) => {
          hide()
          that.transactions = res.data.data
          that.total = res.data.total
        })
    },
    getTypeClass(type) {
      const classes = {
        1: 'withdraw',
        2: 'reward',
        3: 'payment'
      }
      return classes[type] || 'default'
    },
    getTypeIcon(type) {
      const icons = {
        1: 'fa-wallet',
        2: 'fa-gift',
        3: 'fa-credit-card'
      }
      return icons[type] || 'fa-exchange-alt'
    },
    getTypeDesc(type) {
      const descs = {
        1: this.$t('_jyjl._tp1'),
        2: this.$t('_jyjl._tp2'),
        3: this.$t('_jyjl._tp3'),
        4: this.$t('_jyjl._tp4'),
        5: this.$t('_jyjl._tp5'),
        6: this.$t('_jyjl._tp6'),
        7: this.$t('_jyjl._tp7'),
        8: this.$t('_jyjl._tp8'),
        9: this.$t('_jyjl._tp9'),
        10: this.$t('_jyjl._tp10'),
        11: this.$t('_jyjl._tp11')
      }
      return descs[type] || ''
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('zh-CN')
    },
    formatTime(date) {
      return new Date(date).toLocaleTimeString('zh-CN', {
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    formatFullTime(date) {
      return new Date(date).toLocaleString('zh-CN')
    },
    showDetail(transaction) {
      this.selectedTransaction = transaction
    },
    repeatAction(transaction) {
      this.$message.info(`重复操作: ${transaction.type}`)
    },
    exportData() {
      this.$message.success('数据导出成功')
    },
    resetFilters() {
      this.filters = {
        type: 'all',
        dateRange: 'all',
        search: '',
        sortBy: 'time'
      }
      this.page = 1
    }
  }
}
</script>

<style scoped>
@import url('../../static/css_walletlog/1.css');
</style>
